import React from "react";
import { PureAppComponent } from "../../../Components/AppComponent";
import { Form, Button, Table } from "react-bootstrap";
import { connect } from "react-redux";
import _ from "lodash";

import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import AppModal from "../../../Components/Models/app-modal";
import EditCustomer from "../CustomersScreen/EditCustomer";
import { getFullName } from "../../../Modules/utils/fullname";
import api from "../../../Services/Api/api";
import { getPhoneNumber } from "../../../Modules/utils/phoneno";
import EditAccount from "./EditAccount";
import TransactionsScreen from "../TransactionsScreen/TransactionsScreen";
import RenderAmount from "../../../Components/etc/RenderAmount";
import interestModule from "../../../Modules/interest/interestModule";
import PrintCustomerReceipt from "./PrintCustomerReceipt";
import ConfirmationModal from "../../../Components/Models/confirmation-modal";
import ReactToPrint from "react-to-print";
import { monthDiff } from "../../../Modules/utils/etc";
import ReopenAccount from "./ReopenAccount";

const SCREEN_NAME = "ACCOUNT_DETAILS_SCREEN";

class AccountDetailsInner extends PureAppComponent {
  state = {
    loading: "account",
    error: null,
    visibleModal: null,
    modalData: null,
    accountClosingLoader: null,
  };

  componentDidMount() {
    this.onMount();
    this.load();
  }

  async load() {
    try {
      this.setAsyncState({ loading: "account", error: null });

      const { accounts } = await api.get("v1/account", {
        queryStr: JSON.stringify({
          where: { shortId: this.props.shortId },
          limit: 1,
          populate: "customer collector",
        }),
      });

      if (!accounts?.[0]) throw new Error("Account Not Found");

      this.setAsyncState({ loading: false, account: accounts[0] });
    } catch (e) {
      this.setAsyncState({ loading: false, error: e.message });
    }
  }

  onUpdateAccount() {
    this.setAsyncState({ visibleModal: null });
    this.load();
  }

  onUpdateCustomer() {
    this.setAsyncState({ visibleModal: null });
    this.load();
  }

  async closeAccount() {
    try {
      if (this.state.accountClosingLoader) return null;

      const { modalData } = this.state;

      this.setAsyncState({
        accountClosingLoader: true,
        error: null,
        visibleModal: null,
      });
      await api.put(`v1/account/${modalData.account._id}/close`);
      await this.load();
      await this.setAsyncState({ accountClosingLoader: false });
    } catch (e) {
      this.setAsyncState({
        accountClosingLoader: false,
        error: `Error closing account: ${e.message}`,
      });
    }
  }

  async reopenAccount() {
    try {
      if (this.state.accountClosingLoader) return null;

      const { modalData } = this.state;

      this.setAsyncState({
        accountClosingLoader: true,
        error: null,
        visibleModal: null,
      });

      await api.put(`v1/account/${modalData.account._id}/reopen`);
      await this.load();
      await this.setAsyncState({ accountClosingLoader: false });
    } catch (e) {
      this.setAsyncState({
        accountClosingLoader: false,
        error: `Error reopening account: ${e.message}`,
      });
    }
  }

  detailsRow(opt) {
    const {
      state: { account, accountClosingLoader },
    } = this;

    const customer = account.customer || {};

    return (
      <div
        className={`detailsrow ${
          opt?.printingDetails ? "printaccountdetails" : ""
        }`}
      >
        <div className="column">
          <div className="titlerow">
            <Form.Label>Account Details</Form.Label>
            <div style={opt?.printingDetails ? { display: "none" } : null}>
              <Button
                variant="secondary"
                size="sm"
                onClick={() =>
                  account?._id &&
                  this.setAsyncState({
                    visibleModal: "editAccount",
                    modalData: { account },
                  })
                }
              >
                Edit
              </Button>
            </div>
          </div>

          <Table striped bordered hover size="sm" className="vertical-table">
            <tbody>
              <tr>
                <th>Account ID</th>
                <td>{account.shortId}</td>
              </tr>
              <tr>
                <th>Account Type</th>
                <td>{_.startCase(account.accountType)}</td>
              </tr>
              <tr>
                <th>Balance</th>
                <td>
                  <RenderAmount
                    style={{ textAlign: "left" }}
                    value={
                      opt?.printingDetails &&
                      account?.accountType === "deposit" &&
                      account?.balance
                        ? account?.balance * -1
                        : account?.balance
                    }
                  />
                </td>
              </tr>
              <tr>
                <th style={{ minWidth: "130px" }}>Interest Rate</th>
                <td>{account?.interestRate}%</td>
              </tr>
              {account.accountType === "deposit" ? (
                <tr>
                  <th>Deposit Interval</th>
                  <td>{account?.depositInterval}</td>
                </tr>
              ) : null}
              {account.accountType === "deposit" ? (
                <tr>
                  <th>Period</th>
                  <td>
                    {monthDiff(account.openingDate, account.endingDate)} months
                  </td>
                </tr>
              ) : (
                <tr>
                  <th>Interest Period</th>
                  <td>{account?.interestPeriod}</td>
                </tr>
              )}
              {account.accountType === "deposit" ? (
                <tr>
                  <th style={{ minWidth: "130px" }}>Avg Yearly Interest</th>
                  <td>
                    {account?.extra?.avgYearlyInterestRate
                      ? `${account.extra.avgYearlyInterestRate}%`
                      : ""}
                  </td>
                </tr>
              ) : (
                <tr>
                  <th style={{ minWidth: "130px" }}>Avg Yearly Interest</th>
                  <td>
                    {interestModule
                      .calculateAvgYearlyInterest(account)
                      ?.toFixed(2)}
                    %
                  </td>
                </tr>
              )}
              <tr>
                <th>Opening Date</th>
                <td>
                  {new Date(
                    account.accountType === "deposit"
                      ? account.openingDate
                      : account.createdAt
                  ).toLocaleDateString()}
                </td>
              </tr>
              {account.accountType === "deposit" ? (
                <>
                  <tr>
                    <th>Recurring Amount</th>
                    <td>{account.recurringAmount}</td>
                  </tr>
                  <tr>
                    <th>Ending Date</th>
                    <td>{new Date(account.endingDate).toLocaleString()}</td>
                  </tr>
                  {account.returningDate ? (
                    <tr>
                      <th>Returning Date</th>
                      <td>
                        {new Date(account.returningDate).toLocaleDateString()}
                      </td>
                    </tr>
                  ) : null}
                </>
              ) : null}
              <tr>
                <th>Collector</th>
                <td>{getFullName(account?.collector)}</td>
              </tr>
              <tr>
                <th>Collector's Commission</th>
                <td>{account?.collectorCommission}</td>
              </tr>
              <tr>
                <th>Note</th>
                <td className="multiline">{account?.note}</td>
              </tr>
              {account.closed ? (
                <>
                  <tr>
                    <th>Status</th>
                    <td>
                      <div className="red">Closed</div>
                    </td>
                  </tr>
                  <tr>
                    <th>Closing Date</th>
                    <td>
                      {new Date(account.closingDate).toLocaleDateString()}
                    </td>
                  </tr>
                </>
              ) : null}
            </tbody>
          </Table>
        </div>
        <div className="column">
          <div>
            <div className="titlerow">
              <Form.Label>Customer Details</Form.Label>
              <div style={opt?.printingDetails ? { display: "none" } : null}>
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={() =>
                    customer._id &&
                    this.setAsyncState({
                      visibleModal: "editCustomer",
                      modalData: { customer },
                    })
                  }
                >
                  Edit
                </Button>
              </div>
            </div>
            <Table striped bordered hover size="sm">
              <tbody>
                <tr>
                  <th>Name</th>
                  <td>{getFullName(customer)}</td>
                </tr>
                <tr>
                  <th>Phone</th>
                  <td>{getPhoneNumber(customer).formated}</td>
                </tr>
                <tr>
                  <th>Email</th>
                  <td>{customer.email}</td>
                </tr>
                <tr>
                  <th>Address</th>
                  <td className="multiline">{customer.address}</td>
                </tr>
              </tbody>
            </Table>
          </div>

          <div
            className="flex spaceBetween"
            style={opt?.printingDetails ? { display: "none" } : null}
          >
            <Button
              disabled={!account?._id}
              onClick={() => {
                this.setAsyncState({
                  visibleModal: "customerReceipt",
                  modalData: { account },
                });
              }}
            >
              Customer Receipt
            </Button>

            {account.closed ? (
              <Button
                variant="danger"
                disabled={!account?._id || accountClosingLoader}
                onClick={() => {
                  this.setAsyncState({
                    visibleModal: "reopenConfirmation",
                    modalData: { account },
                  });
                }}
              >
                Reopen Account
              </Button>
            ) : (
              <Button
                variant="danger"
                disabled={!account?._id || accountClosingLoader}
                onClick={() => {
                  this.setAsyncState({
                    visibleModal: "closeConfirmation",
                    modalData: { account },
                  });
                }}
              >
                Close Account
              </Button>
            )}
            <Button
              disabled={!account?._id || accountClosingLoader}
              onClick={() => {
                this.setAsyncState({
                  visibleModal: "printDetails",
                });
              }}
            >
              Print Details
            </Button>
          </div>
        </div>
      </div>
    );
  }

  printDetailsRef = React.createRef(null);
  reactToPrintTrigger = () => {
    return (
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button size="sm" variant="secondary">
          Print
        </Button>
      </div>
    );
  };
  printDetails() {
    return (
      <>
        <ReactToPrint
          content={() => this.printDetailsRef?.current}
          documentTitle={`account-details-${this.state?.account?.shortId}`}
          onAfterPrint={() => this.setAsyncState({ visibleModal: null })}
          // onBeforeGetContent={this.handleOnBeforeGetContent}
          // onBeforePrint={this.handleBeforePrint}
          removeAfterPrint
          trigger={this.reactToPrintTrigger}
        />

        <div
          className="account-details"
          style={{
            border: "1px solid lightgray",
            boxShadow: "lightgrey 3px 3px 9px",
          }}
        >
          <div ref={this.printDetailsRef} style={{ padding: "1.5rem" }}>
            <center>
              <h5 style={{}}>TN Dhing</h5>
            </center>
            {this.detailsRow({ printingDetails: true })}
          </div>
        </div>
      </>
    );
  }

  renderInner() {
    const {
      state: {
        account,
        loading,
        error,
        visibleModal,
        modalData,
        accountClosingLoader,
      },
    } = this;

    return (
      <div className="account-details">
        {["account"].includes(loading) || accountClosingLoader ? (
          <center>Loading...</center>
        ) : null}
        {error ? <div className="errormsg">{error}</div> : null}

        {account ? this.detailsRow() : null}

        {account?._id ? (
          <TransactionsScreen
            contentOnly
            account={account}
            additionalQueries={{ where: { $and: [{ account: account._id }] } }}
            filteredColumns={[
              "t",
              "transactionType",
              "credit",
              "debit",
              "balance",
            ]}
            onNewTransaction={() => this.load()}
            scrollSelector=".modal-body"
          />
        ) : null}

        <EditCustomer
          {...{
            key: `editCustomer-${
              visibleModal === "editCustomer"
                ? modalData?.customer?._id?.toString() || "new"
                : "disabled"
            }`,
            renderModal: true,
            visible: visibleModal === "editCustomer",
            handleClose: () => this.setAsyncState({ visibleModal: null }),
            onSubmit: () => this.onUpdateCustomer(),
            ...(modalData || {}),
          }}
        />

        <EditAccount
          {...{
            key: `editAccount-${
              visibleModal === "editAccount"
                ? modalData?.account?._id?.toString() || "new"
                : "disabled"
            }`,

            renderModal: true,
            visible: visibleModal === "editAccount",

            handleClose: () => this.setAsyncState({ visibleModal: null }),
            onSubmit: () => this.onUpdateAccount(),
            ...(modalData || {}),
          }}
        />

        <PrintCustomerReceipt
          {...{
            key: `customerReceipt-${
              visibleModal === "customerReceipt"
                ? modalData?.account?._id?.toString() || "null"
                : "disabled"
            }`,
            renderModal: true,
            visible: visibleModal === "customerReceipt",
            handleClose: () => this.setAsyncState({ visibleModal: null }),

            ...(modalData || {}),
          }}
        />

        <ConfirmationModal
          visible={visibleModal === "closeConfirmation"}
          handleClose={() => this.setAsyncState({ visibleModal: null })}
          onSubmit={this.closeAccount.bind(this)}
          body={`Are you sure you want to close this account of ${getFullName(
            modalData?.account?.customer
          )}, account id ${modalData?.account?.shortId}?`}
          submitBtnText="Close Account"
          title="Confirm Account Closing"
        />

        {/* <ConfirmationModal
          visible={visibleModal === "reopenConfirmation"}
          handleClose={() => this.setAsyncState({ visibleModal: null })}
          onSubmit={this.reopenAccount.bind(this)}
          body={`Are you sure you want to re-open this account of ${getFullName(
            modalData?.account?.customer
          )}, account id ${modalData?.account?.shortId}?`}
          submitBtnText="Reopen Account"
          title="Confirm Account Reopen"
        /> */}

        <ReopenAccount
          {...{
            key: `reopenAccount-${
              visibleModal === "reopenConfirmation"
                ? modalData?.account?._id?.toString() || "new"
                : "disabled"
            }`,

            renderModal: true,
            visible: visibleModal === "reopenConfirmation",

            handleClose: () => this.setAsyncState({ visibleModal: null }),
            onSubmit: () => this.onUpdateAccount(),
            ...(modalData || {}),
          }}
        />

        <AppModal
          {...{
            visible: visibleModal === "printDetails",
            handleClose: () => this.setAsyncState({ visibleModal: null }),
            showFooter: false,
          }}
        >
          {visibleModal === "printDetails" ? this.printDetails() : null}
        </AppModal>
      </div>
    );
  }

  renderModal() {
    return (
      <AppModal
        {...{
          visible: this.props.visible,
          handleClose: this.props.handleClose,
          title: `Account ID: ${this.props.shortId}`,
          showFooter: false,
          modalProps: {
            fullscreen: "lg-down",
            size: "lg",
            scrollable: true,
          },
          enablePrinting: true,
        }}
      >
        {this.renderInner()}
      </AppModal>
    );
  }

  render() {
    const {
      props: { renderModal = false, shortId },
    } = this;

    if (!shortId) return null;
    else if (renderModal) return this.renderModal();
    else return this.renderInner();
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

const AccountDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountDetailsInner);

export default AccountDetails;
